var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 35,
    cy: 34.6385,
    rx: 35,
    ry: 34.5,
    fill: "url(#paint0_linear_3028_2125)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1922 30.2456H39.9963C41.3499 30.2456 42.4473 31.3274 42.4473 32.6616V48.3657H27.7412V32.6616C27.7412 31.3274 28.8387 30.2456 30.1922 30.2456Z",
    fill: "#F5DE5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3534 47.7614H41.8341V32.6614C41.8341 31.6624 41.0095 30.8494 39.9958 30.8494H30.1917C29.178 30.8494 28.3534 31.6624 28.3534 32.6614V47.7614ZM43.0596 48.9695H27.1279V32.6614C27.1279 30.9962 28.5026 29.6414 30.1917 29.6414H39.9958C41.6849 29.6414 43.0596 30.9962 43.0596 32.6614V48.9695Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4473 35.6815H27.7412V34.4733H42.4473V35.6815Z",
    fill: "#595959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1598 41.7217H36.9343V43.5337C36.9343 44.5327 36.1097 45.3457 35.096 45.3457C34.0823 45.3457 33.2577 44.5327 33.2577 43.5337V41.7217H32.0322V43.5337C32.0322 45.1989 33.4069 46.5537 35.096 46.5537C36.7851 46.5537 38.1598 45.1989 38.1598 43.5337V41.7217Z",
    fill: "#595959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0341 39.3055H38.1617V38.0972H32.0341V39.3055ZM39.3872 40.5137H30.8086V36.889H39.3872V40.5137Z",
    fill: "#595959"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7121 39.7585H34.4863V37.3419H35.7121V39.7585Z",
    fill: "#595959"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0899 48.9695H44.2858V47.7614H52.8644V26.6214C52.8644 26.288 52.5899 26.0174 52.2517 26.0174H41.2221C40.8838 26.0174 40.6093 26.288 40.6093 26.6214V28.4334H39.3838V26.6214C39.3838 25.6224 40.2084 24.8094 41.2221 24.8094H52.2517C53.2653 24.8094 54.0899 25.6224 54.0899 26.6214V48.9695Z",
    fill: "#595959"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9047 48.9695H16.1006V26.6214C16.1006 25.6224 16.9252 24.8094 17.9389 24.8094H28.9685C29.9821 24.8094 30.8067 25.6224 30.8067 26.6214V28.4334H29.5812V26.6214C29.5812 26.288 29.3067 26.0174 28.9685 26.0174H17.9389C17.6006 26.0174 17.3261 26.288 17.3261 26.6214V47.7614H25.9047V48.9695Z",
    fill: "#595959"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8635 25.4134H51.638V24.2052C51.638 23.8717 51.3635 23.601 51.0252 23.601H42.4467C42.1084 23.601 41.8339 23.8717 41.8339 24.2052V25.4134H40.6084V24.2052C40.6084 23.2059 41.433 22.3928 42.4467 22.3928H51.0252C52.0389 22.3928 52.8635 23.2059 52.8635 24.2052V25.4134Z",
    fill: "#595959"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5823 25.4134H28.3568V24.2052C28.3568 23.8717 28.0822 23.601 27.744 23.601H19.1654C18.8272 23.601 18.5527 23.8717 18.5527 24.2052V25.4134H17.3271V24.2052C17.3271 23.2059 18.1517 22.3928 19.1654 22.3928H27.744C28.7577 22.3928 29.5823 23.2059 29.5823 24.2052V25.4134Z",
    fill: "#595959"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9965 27.2257H30.1924V26.0174H39.9965V27.2257Z",
    fill: "#595959"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1887 29.6416H50.4144V28.4334H49.1887V29.6416ZM51.6402 30.8499H47.9629V27.2251H51.6402V30.8499Z",
    fill: "#595959"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2873 29.6416H45.513V28.4334H44.2873V29.6416ZM46.7388 30.8499H43.0615V27.2251H46.7388V30.8499Z",
    fill: "#595959"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1887 34.4733H50.4144V33.265H49.1887V34.4733ZM51.6402 35.6815H47.9629V32.0568H51.6402V35.6815Z",
    fill: "#595959"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 45.3452H50.4156V44.1369H45.5136V45.3452ZM51.6412 46.5534H44.2881V42.9287H51.6412V46.5534Z",
    fill: "#595959"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 40.5132H50.4156V39.3049H45.5136V40.5132ZM51.6412 41.7214H44.2881V38.0967H51.6412V41.7214Z",
    fill: "#595959"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5763 45.9487H47.3506V43.5322H48.5763V45.9487Z",
    fill: "#595959"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5763 41.1173H47.3506V38.7008H48.5763V41.1173Z",
    fill: "#595959"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7775 29.6416H21.0033V28.4334H19.7775V29.6416ZM22.229 30.8499H18.5518V27.2251H22.229V30.8499Z",
    fill: "#595959"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6799 29.6416H25.9056V28.4334H24.6799V29.6416ZM27.1314 30.8499H23.4541V27.2251H27.1314V30.8499Z",
    fill: "#595959"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7775 34.4733H21.0033V33.265H19.7775V34.4733ZM22.229 35.6815H18.5518V32.0568H22.229V35.6815Z",
    fill: "#595959"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7773 45.3452H24.6793V44.1369H19.7773V45.3452ZM25.9048 46.5534H18.5518V42.9287H25.9048V46.5534Z",
    fill: "#595959"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7773 40.5132H24.6793V39.3049H19.7773V40.5132ZM25.9048 41.7214H18.5518V38.0967H25.9048V41.7214Z",
    fill: "#595959"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 45.9487H21.6143V43.5322H22.84V45.9487Z",
    fill: "#595959"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 41.1173H21.6143V38.7008H22.84V41.1173Z",
    fill: "#595959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3028_2125",
    x1: 35,
    y1: 0.13855,
    x2: 35,
    y2: 69.1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon);
export default __webpack_public_path__ + "static/media/hotelIcon.a904a32cefe733f811154e01cfcbc858.svg";
export { ForwardRef as ReactComponent };